import { cn } from '@/lib/cn.js';

export function Table({ className, ...props }) {
  return (
    <div className="w-full overflow-auto rounded-lg border border-slate-200 dark:border-slate-800">
      <table className={cn('w-full caption-bottom text-sm', className)} {...props} />
    </div>
  );
}

export function THead({ className, ...props }) {
  return <thead className={cn('bg-slate-50 dark:bg-slate-800/60', className)} {...props} />;
}

export function TBody({ className, ...props }) {
  return <tbody className={cn('divide-y divide-slate-100 dark:divide-slate-800', className)} {...props} />;
}

export function TR({ className, ...props }) {
  return <tr className={cn('hover:bg-slate-50 dark:hover:bg-slate-800/40', className)} {...props} />;
}

export function TH({ className, ...props }) {
  return (
    <th
      className={cn(
        'h-10 px-3 text-left text-xs font-semibold tracking-wide text-slate-500 dark:text-slate-400',
        className,
      )}
      {...props}
    />
  );
}

export function TD({ className, ...props }) {
  return <td className={cn('px-3 py-2 text-slate-700 dark:text-slate-200', className)} {...props} />;
}
